const Fullwidth = {
    classNames: {
        title: 'full-width__title',
        content: 'full-width__copy',
        button: 'full-width__button'
    }
};

export default Fullwidth;
